import React, { useContext, useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { useUpdateIMage } from "./store";
import { get, isEmpty } from "lodash";
import { currentUser, userCanEdit } from "modules/utilities/utility";
import { CustomerProps } from "./ShowCustomer";
import { FEMALE_STAGE } from "config";
import { MALE_STAGE } from "config";


function HairFallStage({ imageUrls }) {
  const [selectedStage, setSelectedStage] = useState(null);
  const { updateImageData } = useUpdateIMage();
  const adminFlag = userCanEdit.includes(currentUser);
  const {customerInfo = {}} = useContext(CustomerProps) || {};
  const { gender = 'M' } = customerInfo;
  const stages = gender === 'F' ? FEMALE_STAGE : MALE_STAGE;

  const stageMarkFlag = imageUrls?.find((item) => !isEmpty(item.tagged_stage));

  useEffect(() => {
    if (stageMarkFlag) {
      setSelectedStage(stageMarkFlag.tagged_stage);
    }
  }, [stageMarkFlag]);

  const handleCantSay = () => {
    const imageId = get(imageUrls, "[0].id");
    if (imageId) {
      updateImageData(imageId, { stage: "can not say" });
    }
  };

  const handleSubmit = () => {
    const imageId = get(imageUrls, "[0].id");
    if (imageId && selectedStage) {
      updateImageData(imageId, { stage: selectedStage });
    }
  };

  const isDisabled = !isEmpty(stageMarkFlag);

  return (
    <div className="border rounded bg-light shadow-sm mb-n3">
      <div className={`d-flex mt-1 align-items-center mb-1 justify-content-center${isDisabled ? "my-3" : ""}`}>
        <div className="font-poppins fw-bold text-nowrap mx-1">Tag Hair Fall Stage:</div>
        <div className="mx-1">
          <Form.Select
            size="md"
            className="form-control-sm"
            value={selectedStage || ""}
            onChange={(event) => setSelectedStage(event.target.value)}
          >
            {stages.map((stage) => (
              <option key={stage} value={stage}>
                {stage}
              </option>
            ))}
          </Form.Select>
        </div>
      </div>
      {(!isDisabled || adminFlag)&& <div className="d-flex gap-3 ms-4 me-2 mt-1 mb-1 justify-content-center">
        <Button
          variant="secondary"
          size="sm"
          onClick={handleCantSay}
          disabled={isDisabled && !adminFlag}
        >
          Can't say
        </Button>
        <Button
          variant="primary"
          size="sm"
          onClick={handleSubmit}
          disabled={isDisabled && !adminFlag}
        >
          Submit
        </Button>
      </div>}
    </div>
  );
}

export default HairFallStage;
